import {createAction, props} from '@ngrx/store';
import {IFieldType} from '../_interface/ifield-type';

export const loadFieldTypes = createAction(
	'[Journal 📦 FieldTypes] Loaded 👍',
	props<{ fieldTypes: IFieldType[] }>()
);
